export default function Footer() {
  return (
    <footer className="bg-gray-800 py-10 text-center text-white">
      <p>&copy; Visawjeet Mallik, 2022</p>
      <a href="https://github.com/vishmallik">
        <i className="fab fa-github  cursor-pointer pt-4 text-4xl hover:text-amber-400"></i>
      </a>
    </footer>
  );
}
